import VrrTablePagination from './VrrTablePagination';

export default VrrTablePagination;
